module.exports = {"pathContext":{"slug":"/es/terms_conditions/","langKey":"es"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/es-terms-conditions.json
// module id = 1233
// module chunks = 151582923344568